import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { collection, limit, onSnapshot, orderBy, query } from 'firebase/firestore';
import Link from 'next/link';
import React, { useEffect, useState } from 'react';
import { db } from '../firebase-client';
import formatNumber from '../utils/formatNumber';
import { VM_TOKEN_AMOUNT_NEEDED } from '../utils/vending-machine';
import ProfileAvatar from './ProfileAvatar';
import WalletAddress from './WalletAddress';

dayjs.extend(relativeTime);

const q = query(collection(db, process.env.NEXT_PUBLIC_VENDING_PURCHASES_COLLECTION), limit(10), orderBy('createdAt', 'desc'));

function VendingBuysFeed() {
  const [buys, setBuys] = useState([]);

  useEffect(() => {
    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const them = querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
      setBuys(them);
    });

    // unsubscribe from the listener when the component unmounts
    return () => unsubscribe();
  }, []);

  return (
    <div className='max-w-2xl mx-auto w-full mt-20'>
      <h2 className='text-center mb-4 text-white font-bold text-2xl'>Recent Purchases</h2>
      <div className='rounded-lg bg-gray-900 p-2 md:p-8 max-h-[350px] overflow-y-scroll'>
        <ul>
          {buys.map((buy) => (
            <VendingBuysFeedItem item={buy} key={buy.id} />
          ))}
        </ul>
      </div>
    </div>
  );
}

function VendingBuysFeedItem({ item }) {
  const receivedFrom =
    item.from === 'vm'
      ? item.vmTokenBalance >= VM_TOKEN_AMOUNT_NEEDED
        ? `for ${VM_TOKEN_AMOUNT_NEEDED} VM Tokens`
        : `for ${item.cost} treats`
      : 'from a Treasure Box';

  if (item.failed) {
    return (
      <li className='flex md:flex-row gap-1 flex-col justify-between odd:bg-gray-800 p-3 rounded-lg text-sm'>
        <p className='text-gray-400 mr-8'>
          ❌{' '}
          <Link href={`/profile/${item.address}`}>
            <a className='text-white'>
              <strong>
                <WalletAddress address={item.address} />
              </strong>
            </a>
          </Link>{' '}
          spent 250 treats but the machine broke.
        </p>
        <p className='text-gray-400'>{dayjs(item.createdAt.toDate()).fromNow()}</p>
      </li>
    );
  }

  return (
    <li className='flex md:flex-row gap-1 flex-col justify-between odd:bg-gray-800 p-3 rounded-lg text-sm'>
      <div className='flex items-center mr-2'>
        <ProfileAvatar width={25} address={item.address} />
      </div>
      <p className='text-gray-400 flex-1 mr-8'>
        <Link href={`/profile/${item.address}`}>
          <a className='text-white'>
            <strong>
              <WalletAddress address={item.address} />
            </strong>
          </a>
        </Link>{' '}
        received{' '}
        {item.amount > 1 ? (
          <span className='text-white font-bold'>
            {formatNumber(item.amount)} {item.nft.name}
          </span>
        ) : (
          <a href={`https://www.randgallery.com/algo-collection/?address=${item.nft.index}`} target='_blank' className='text-white font-bold'>
            {item.nft.name}
          </a>
        )}{' '}
        {item.from === 'vm' ? receivedFrom : 'from a Treasure Box.'}
      </p>
      <div className='flex items-center'>
        <p className='text-gray-400'>{dayjs(item.createdAt.toDate()).fromNow()}</p>
      </div>
    </li>
  );
}

export default VendingBuysFeed;
